export default __webpack_public_path__ + "static/media/expand-3.39f90beb.svg";